<template>
    <div class="content">
        <SswgModal :visible.sync="modalVisible" :modalTitle="modalTitle" class="sswg-modal">
            <div class="modal-content" style="border: none;">
                <div class="vv">
                    <span class="title">航段信息</span>
                    <div class="box">
                        <div class="ship">
                            <ul class="table-title" style="cursor: default;">
                                <li class="w1">序号</li>
                                <li class="w2">起始点</li>
                                <li class="w3">终止点</li>
                                <li class="w4">偏航距离(米)</li>
                                <li class="w5"></li>
                            </ul>
                            <ul v-for="(item, i) in dataList" :key="i" :style="{backgroundColor: currSegmId==item.id?'#3ebcf6':''}">
                                <li class="w1">{{ i+1 }}</li>
                                <li class="w2">{{ item.startPointName }}</li>
                                <li class="w3">{{ item.endPointName }}</li>
                                <li class="w4">{{ item.yawDistance }}</li>
                                <li class="w5">
                                    <span class="btn" @click="edit(item)">编辑</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="vv" style="margin-top: 10px;">
                    <span class="title">船舶设置</span>
                    <div class="box">
                        <div class="ship">
                            <ul class="table-title" style="cursor: default;">
                                <li class="c1">序号</li>
                                <li class="c2">天线设备ID</li>
                                <li class="c3">船舶名称</li>
                                <li class="c4">是否导航</li>
                            </ul>
                            <ul v-for="(item, i) in shipList" :key="i">
                                <li class="c1">{{ i+1 }}</li>
                                <li class="c2">{{ item.positionDeviceId }}</li>
                                <li class="c3">{{ item.name }}</li>
                                <li class="c4">
                                    <input type="checkbox" class="sswg-checkbox" v-model="checkedShipIdArr" :value="item.id" @click="settingRouteShipWarn(item.id)"></input>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </SswgModal>
        <SswgModal :visible.sync="modalVisible2" modalTitle="设置偏航距离" class="sswg-modal" :openFooter=true @sure="sure">
            <div class="segm">
                <span>偏航距离(米)</span>
                <el-input-number v-model="yawDistance" :controls=false :min="1" :max="100" :precision="0" label="偏航距离(米)"></el-input-number>
            </div>
        </SswgModal>
    </div>
</template>

<script>

export default {
    inject: ['parent'],
    data() {
        return {
            currOperate: '', // 当前操作 add edit del
            currWayId: 0,

            modalVisible2: false,
            dataList: [],       // 航段列表
            currSegmId: 0,      // 当前航段id
            yawDistance: '',    // 偏航距离

            modalVisible: false,
            modalTitle: '航线设置',

            shipList: [],
            outletsIdList: [],
            currWarnCategoryId: 0,

            checkedShipIdArr: []
        }
    },

    methods: {

        // 查询标注告警类目
        queryDataById(){
            this.sswgPost('/route/fetchSegmentListByRouteId', {id: this.currWayId}, true, 'json').then(res => {
                if(res && res.code==200){
                    this.dataList = res.data
                }
            })
        },

        // 查询船舶勾选
        queryDataShipById(){
            this.sswgPost('/warnRouteShip/fetchWarnRouteShipList', {routeId: this.currWayId}, true, 'json').then(res => {
                if(res && res.code==200){
                    let arr = res.data
                    if(arr.length>0){
                        for(let i=0; i<arr.length; i++){
                            this.checkedShipIdArr.push(arr[i].shipInfoId)
                        }
                    }
                }
            })
        },

        // 重置
        resetData(){
            this.currSegmId = 0
            this.shipList = []
            this.currWarnCategoryId = 0
            this.checkedShipIdArr = []
        },

        /**
         * 设置当前操作
         * @param oper setting 
         * @param way 航线
         */
        setCurrOperate(oper, way){
            this.resetData()
            if(oper=='setting'){
                this.currWayId = way.id
                // 共用船舶信息
                this.shipList = this.parent.app.shipList
                this.queryDataById()
                this.queryDataShipById()
            }
        },

        edit(item){
            this.currSegmId = item.id
            this.yawDistance = item.yawDistance
            this.modalVisible2 = true
        },

        // 导航
        settingRouteShipWarn(shipId){
            let b = this.checkedShipIdArr.includes(shipId)
            let p = {
                shipInfoId: shipId,
                isChecked: !b,
                routeId: this.currWayId
            }
            this.sswgPost('/warnRouteShip/settingRouteShipWarn', p, true, 'json').then(res => {
                this.$message.success('操作成功')
            })
        },

        // 确认
        sure(){
            let p = {
                id: this.currSegmId,
                yawDistance: this.yawDistance
            }
            this.sswgPost('/route/updateYawDistance', p, true, 'json').then(res => {
                this.modalVisible2 = false
                this.queryDataById()
            })
        },

        close(){
            this.currOperate = ''
            this.modalVisible = false
        },

        setShow(){
            this.modalVisible = true
        }
    }

}

</script>

<style lang="scss" scoped>
    .content {
        .segm {
            width: 300px;
            height: 40px;
            padding: 10px;
            margin-bottom: 20px;
            line-height: 40px;
            span {
                padding-right: 10px;
            }
        }
        .modal-content {
            width: 500px;
            padding: 10px;
            border: 1px solid #FFFFFF;
            border-radius: 0;
            .vv {
                .title {
                    font-size: 12px;
                }
                .box {
                    margin-top: 5px;
                    border: 1px solid #a0bed5;
                    border-radius: 5px;
                    padding: 10px;
                    .ship {
                        background-color: #FFFFFF;
                        min-height: 220px;
                        max-height: 320px;
                        overflow-y: auto;
                        ul {
                            display: flex;
                            text-align: center;
                            line-height: 22px;
                            font-size: 12px;
                            color: #000;
                            border-bottom: 1px dashed rgb(180, 179, 179);
                            .c1 {
                                width: 70px;
                            }
                            .c2 {
                                width: 130px;
                            }
                            .c3 {
                                width: 180px;
                            }
                            .c4 {
                                width: 80px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                            .w1 { width: 60px; }
                            .w2 { width: 120px; }
                            .w3 { width: 120px; }
                            .w4 { width: 90px; }
                            .w5 { width: 70px; }
                            .btn {
                                cursor: pointer;
                            }
                        }
                        ul:hover {
                            background-color: #86e9f9;
                        }
                        .table-title {
                            color: #FFF;
                            font-size: 12px;
                            line-height: 20px;
                            user-select: none;
                            background-color: #0393ed;
                        }
                        .table-title:hover{
                            background-color: #0393ed;
                        }
                    }
                }
            }
        }
    }
</style>

<style scoped>
    .modal-content >>> input.el-input__inner {
        font-size: 15px;
        font-weight: bold;
        height: 26px;
        line-height: 26px;
        background: none;
        color: #FFFFFF;
        padding: 0 5px;
    }
    .modal-content >>> .el-checkbox__label {
        color: #ffffff;
    }

    .modal-content >>> .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #FFFFFF;
    }

    .segm >>> .el-input__inner {
        height: 26px;
    }
    
</style>

